export class DocumentRequirementField {
  public id: string;
  public fieldName: string;
  public fieldType: string;
  public sortOrder: number;
  public workingLabel: string;
  public validationRequired: boolean = true;
  public useInSfl: boolean = true;
}
